const AUTH_HOST = process.env.AUTH_HOST || 'http://128.199.192.37:9869'

const AUTH_USERNAME = process.env.AUTH_USERNAME || 'nguyenkhoa'
const AUTH_PASSWORD = process.env.AUTH_PASSWORD || '123'
const AUTH_TOKEN = process.env.AUTH_TOKEN || '123'

module.exports = {
    AUTH_HOST,
    AUTH_USERNAME,
    AUTH_PASSWORD,
    AUTH_TOKEN
}
